import React, { isValidElement } from "react";
import { useEnigmaToken } from "@hooks/useEnigmaToken";
import { StyledNoDataLabel, tableEmptyContainer } from "../../table.styles";
import { IEmptyView, ITableProps } from "../../table.types";
import { TableEmptyIcon } from "./tableEmptyIcon";

export const EMPTY_VIEW = {
    text: "No data found",
    icon: <TableEmptyIcon />,
};

function TableEmptyState<T>({
    emptyView = {},
}: Readonly<Pick<ITableProps<T>, "emptyView">>) {
    const token = useEnigmaToken();
    const isNode = isValidElement(emptyView);

    if (isNode) {
        return emptyView;
    }
    const { icon, text } = { ...EMPTY_VIEW, ...(emptyView as IEmptyView) };
    return (
        <div className={tableEmptyContainer}>
            {icon}
            <StyledNoDataLabel token={token}>{text}</StyledNoDataLabel>
        </div>
    );
}

export default TableEmptyState;
